import React, { useEffect, useState } from 'react';

const RainEffect = () => {
    const [raindrops, setRaindrops] = useState([]);
    const [thunder, setThunder] = useState(false);
    const [lightningPaths, setLightningPaths] = useState([]);

    // Procedural generation of a lightning bolt with branching roots
    const generateLightningPath = (startX, startY, endX, endY, displace) => {
        if (displace < 4) {
            return [`M ${startX} ${startY} L ${endX} ${endY}`];
        }

        const midX = (startX + endX) / 2;
        const midY = (startY + endY) / 2;
        
        // Random horizontal displacement
        const offset = (Math.random() - 0.5) * displace;
        const displacedMidX = midX + offset;

        // Create main branches
        const left = generateLightningPath(startX, startY, displacedMidX, midY, displace * 0.55);
        const right = generateLightningPath(displacedMidX, midY, endX, endY, displace * 0.55);

        let paths = [...left, ...right];

        // 25% chance to create a branching root structure
        if (Math.random() < 0.25 && displace > 20) {
            const forkX = displacedMidX + (Math.random() - 0.3) * displace * 2.5;
            const forkY = midY + (Math.random() * (endY - midY) * 0.6);
            const branch = generateLightningPath(displacedMidX, midY, forkX, forkY, displace * 0.45);
            paths = [...paths, ...branch];
        }

        return paths;
    };

    useEffect(() => {
        // Generate raindrops
        const drops = [];
        const count = 120; // Number of raindrops

        for (let i = 0; i < count; i++) {
            drops.push({
                id: i,
                left: Math.random() * 100,
                animationDuration: 0.4 + Math.random() * 0.4, // Fall duration (0.4-0.8s)
                animationDelay: Math.random() * 2, // Start delay
                height: 15 + Math.random() * 25, // Length
            });
        }

        setRaindrops(drops);

        // Random thunder & lightning generator
        const thunderInterval = setInterval(() => {
            if (Math.random() > 0.6) { // 40% chance every interval check
                const startX = 150 + Math.random() * 700; // Start location in 1000px grid
                const startY = 0;
                const endX = startX + (Math.random() - 0.5) * 400; // General drift
                const endY = 400 + Math.random() * 550; // Ends somewhere in the lower region

                const paths = generateLightningPath(startX, startY, endX, endY, 150);
                setLightningPaths(paths);
                setThunder(true);

                // Keep the lightning bolt visible for 250ms
                setTimeout(() => {
                    setThunder(false);
                }, 250);
            }
        }, 4000); // Check every 4 seconds

        return () => clearInterval(thunderInterval);
    }, []);

    return (
        <>
            {/* Thunder Screen Flash */}
            {thunder && <div className="thunder-flash" />}

            {/* Glowing Lightning Bolt Overlay */}
            {thunder && (
                <svg
                    className="absolute inset-0 w-full h-full pointer-events-none z-30"
                    viewBox="0 0 1000 1000"
                    preserveAspectRatio="none"
                >
                    <defs>
                        <filter id="lightning-glow" x="-20%" y="-20%" width="140%" height="140%">
                            <feGaussianBlur stdDeviation="8" result="blur" />
                            <feMerge>
                                <feMergeNode in="blur" />
                                <feMergeNode in="SourceGraphic" />
                            </feMerge>
                        </filter>
                    </defs>

                    {/* Glowing outer aura path */}
                    {lightningPaths.map((path, idx) => (
                        <path
                            key={`glow-${idx}`}
                            d={path}
                            fill="none"
                            stroke="#e0f2fe" // Sky-100 glow
                            strokeWidth="8"
                            opacity="0.8"
                            filter="url(#lightning-glow)"
                        />
                    ))}

                    {/* Pure bright core path */}
                    {lightningPaths.map((path, idx) => (
                        <path
                            key={`core-${idx}`}
                            d={path}
                            fill="none"
                            stroke="#ffffff"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    ))}
                </svg>
            )}

            {/* Dark clouds overlay */}
            <div className="rain-clouds" />

            {/* Rain drops */}
            <div className="rain-container">
                {raindrops.map((drop) => (
                    <div
                        key={drop.id}
                        className="raindrop"
                        style={{
                            left: `${drop.left}%`,
                            height: `${drop.height}px`,
                            animationDuration: `${drop.animationDuration}s`,
                            animationDelay: `${drop.animationDelay}s`,
                        }}
                    />
                ))}
            </div>
        </>
    );
};

export default RainEffect;
